import React from 'react';
import { DatePicker, Space, Dropdown, Menu, Input } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { ListDropdown } from '../../interface';

const DropdownAction = (props: ListDropdown) => {
  return (
    <Dropdown overlay={props.list} trigger={['click']} className="dropdownWare">
      <a onClick={(e) => e.preventDefault()}>
        <Space
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <span
            style={{
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              width: '110px'
            }}
          >
            {props.titleSelect}
          </span>
          <DownOutlined />
        </Space>
      </a>
    </Dropdown>
  );
};

export default DropdownAction;
